const t = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="t2-icon--open-caret-left-dark-32px" viewBox="0 0 16 30">\r
<title>open caret left dark 32px</title>\r
<g class="nc-icon-wrapper">\r
<path d="M2.414 15l13.293 13.293a1 1 0 0 1-1.414 1.414l-14-14a1 1 0 0 1 0-1.414l14-14a1 1 0 0 1 1.414 1.414L2.414 15z"/>\r
</g>\r
</svg>\r`;
export {
  t as default
};
